import React from 'react';
import { Formik } from 'formik';
import { FormControlLabel, Checkbox, Theme } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

/**
 * Form with slot and checkbox that confirms slot
 * @param props
 */
export default function(props: {
  children: React.ReactNode;
  label: string;
  onChange: (checked: boolean) => void;
  value: boolean;
}) {
  const classes = useStyles();
  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        agreement: props.value
      }}
      onSubmit={async values => {
        return;
      }}
      validate={values => {
        props.onChange(values.agreement);
      }}
    >
      {({ handleSubmit, handleChange, values }) => (
        <form onSubmit={handleSubmit} className={classes.form} noValidate>
          <div style={{ maxHeight: 500, overflow: 'auto' }}>
            {props.children}
          </div>
          <FormControlLabel
            control={
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="medium" />}
                checkedIcon={<CheckBoxIcon color="primary" fontSize="medium" />}
                name="agreement"
                onChange={handleChange}
                checked={values.agreement}
              />
            }
            label={props.label}
            data-agreement-checkbox
          />
        </form>
      )}
    </Formik>
  );
}
